import { Navigate, Outlet } from "react-router-dom";
import AuthContext from '@providers/context/componenets/AuthContext'
import { useContext } from "react";


export default function GuestGuard() {
    const { isAuthenticated } = useContext(AuthContext)

    if (isAuthenticated) {
        return <Navigate to='/home' replace />;
    }

    return <Outlet />
}